import { Injectable } from "@angular/core";
import type { MyApp } from "app/app.component";
import { WelcomePhase } from "@cf-shared/data-model/fitness-plan";
@Injectable()
export class AppService { 
  
  constructor() {
  }

  setMyApp(myApp: MyApp) {
    this.myApp = myApp;
  }

  private myApp: MyApp;

  changeScreenName(screenName: string) {
    this.myApp.onNewPage(screenName);
  }

  async isUserNew(): Promise<boolean> {
    const plan = await this.myApp.userDb.database.withDocWatcherAsync(watcher => this.myApp.userDb.loadPlanAsync(watcher));
    if (plan.welcomePhase === WelcomePhase.Intro
      || plan.welcomePhase === WelcomePhase.Intake
      || plan.welcomePhase === WelcomePhase.CoachedIntake
      || plan.welcomePhase === WelcomePhase.AwaitingCoachFinalize) {
      // option B (#3389): a client in the middle of coached onboarding
      // (either filling the intake themselves or held on the awaiting-coach
      // page) is still effectively new — global_common needs to be fully
      // synced just as for a non-coach new user.
      return true;
    }

    return false;
  }

}